export enum TypeName {
  String = 'String',
  Int = 'Int',
  Float = 'Float',
}
